import { axiosInstanceV3 } from '@mais-retorno-front/configs/axios-config';
import { GetBenchmarkStatsUseCase } from '../useCases/get-benchmark-stats';

export const makeGetBenchmarkStatsUseCase = () => {
  const url = "/indexes/stats";
  
  return new GetBenchmarkStatsUseCase(
    url,
    axiosInstanceV3
  );
};
